// extracted by mini-css-extract-plugin
export var FormWrapper = "style-module--FormWrapper--d6604";
export var SubmitFormSuccessWrapper = "style-module--SubmitFormSuccessWrapper--47845";